module.exports = __webpack_public_path__ + "media/bootstrap-icons/currency-exchange-b6c42d19.svg";